import { deleteRequest, getRequest, postRequest } from "./request.js";
import { hideLoader, showLoader } from "./utils.js";

const globalCompPresentText = "Select a component from this list to add to your slide";
const globalCompMissingText = "Please create components via Component Tab";
const userCompPresentText = "Components currently being used in your slide:";
const userCompMissingText = "Please add components from the Global Components on the left side";

const updateGlobalComponentsList = async ({ editor, pathName, pId, kmId, setMsg, setError }) => {
  let matchingComponentCount = 0;
  try {
    showLoader();
    const response = await getRequest(`components/list`);
    const globalCompListHolder = document.querySelector("#manage-comp #global-comp-list-group");
    const globalCompListHeading = document.querySelector("#manage-comp #global-comp-heading");

    if (response.data.isSuccess) {
      if (response.data.components.length === 0) {
        globalCompListHolder.innerHTML = "";
        globalCompListHeading.innerHTML = globalCompMissingText;
        globalCompListHeading.nextElementSibling.style.display = "none"
        return;
      }

      let list = "";
      const globalComponents = response.data.components;

      for (const globalComp of globalComponents) {
        matchingComponentCount++;
        const { _id: rcId, name } = globalComp;
        list += `<button data-comp-id="${rcId}" data-comp-name="${name}" class="global-component component-tablet">
          <span>${name}</span>
          <span class="add-comp fa fa-plus" style="margin-left: 15px;"></span>
        </button>`;
      }

      globalCompListHolder.innerHTML = list;
      globalCompListHeading.innerHTML = globalCompPresentText;
      globalCompListHeading.nextElementSibling.style.display = "";

      /*---------Global Component Search--------*/
      const updateComponentCountSpan = (count) => `${count} Component${count === 1 ? "" : "s"}`;
      const globalComponentCountSpan = document.querySelector("#global-comp-list #global-comp-count");
      globalComponentCountSpan.innerHTML = updateComponentCountSpan(matchingComponentCount);

      const globalComponentSearchInput = document.querySelector("#global-comp-list #global-comp-search")
      globalComponentSearchInput.addEventListener("input", (e) => {
        e.stopImmediatePropagation();
        const searchValue = e.target.value.trim().toLowerCase();
        const allGlobalComponents = Array.from(document.querySelectorAll("#global-comp-list .global-component"));
        const matchingGlobalComponents = allGlobalComponents.filter((component) => component.getAttribute("data-comp-name").toLowerCase().includes(searchValue));
        const updatedMatchingCount = matchingGlobalComponents.length;
        globalComponentCountSpan.innerHTML = updateComponentCountSpan(updatedMatchingCount);

        allGlobalComponents.forEach((component) => {
          component.style.display = "none";
        });
        matchingGlobalComponents.forEach((component) => {
          component.style.display = "inline-block";
        })
      });

      const addComp = document.querySelectorAll("#manage-comp #global-comp-list-group span.add-comp");
      addComp.forEach((el) =>
        el.addEventListener("click", async (e) => {
          e.preventDefault();
          const rcId = e.currentTarget.parentNode.getAttribute("data-comp-id");
          const name = e.currentTarget.parentNode.getAttribute("data-comp-name");

          const matchingUserComponents = document.querySelectorAll(`#manage-comp #user-comp-list-group button[data-comp-id="${rcId}"]`);
          if (matchingUserComponents.length > 0) {
            setError(true);
            setMsg("This component is already selected!!");
            hideLoader();
            return;
          }

          const confirm = window.confirm(`Are you sure you wish to add the following component:\n${name}`);
          if (!confirm) return;

          showLoader();
          const response = await postRequest(`components/${rcId}/add-rc-to-km`, { pId, kmId });

          if (response.data.isSuccess) {
            /*----------add component as block---------*/
            const customRcId = `rc-${rcId}`;
            editor.BlockManager.add(customRcId, {
              category: "Components",
              media: `<span class="fa fa-code"></span>`,
              label: `${name}`,
              content: {
                type: "component",
                attributes: {
                  "data-rc-id": rcId
                }
              }
            });

            await updateUserComponentsList({ editor, pathName, pId, kmId, setMsg, setError });
            setError(false);
            setMsg("Component added successfully to key message");
            hideLoader();
          } else {
            setError(true);
            setMsg(response.data.msg);
            hideLoader();
          }
        })
      );
    } else {
      globalCompListHolder.innerHTML = "";
      globalCompListHeading.innerHTML = globalCompMissingText;
      globalCompListHeading.nextElementSibling.style.display = "none"
    }
  } catch (err) {
    console.log(err);
    setError(true);
    setMsg(err.message);
  } finally {
    hideLoader();
  }
};

const updateUserComponentsList = async ({ editor, pathName, pId, kmId, setMsg, setError }) => {
  try {
    showLoader();
    const response = await getRequest(`${pathName}/components`);
    const userCompListHolder = document.querySelector("#manage-comp #user-comp-list-group");
    const userCompListHeading = document.querySelector("#manage-comp #user-comp-heading");
  
    if (response.data.isSuccess) {
      if (response.data.components.length === 0) {
        userCompListHolder.innerHTML = "";
        userCompListHeading.innerHTML = userCompMissingText;
        return;
      }
  
      let list = "";
      const userComponents = response.data.components;
  
      for (const userComp of userComponents) {
        const { _id: rcId, name } = userComp;
        list += `<button data-comp-id="${rcId}" data-comp-name="${name}" class="user-component component-tablet">
          <span>${name}</span>
          <span class="delete-comp fa fa-times" style="margin-left: 15px;"></span>
        </button>`;
      }
  
      userCompListHolder.innerHTML = list;
      userCompListHeading.innerHTML = userCompPresentText;
  
      hideLoader();
      const deleteComp = document.querySelectorAll("#manage-comp #user-comp-list-group span.delete-comp");
      deleteComp.forEach((el) =>
        el.addEventListener("click", async (e) => {
          e.preventDefault();
          const rcId = e.currentTarget.parentNode.getAttribute("data-comp-id");
          const name = e.currentTarget.parentNode.getAttribute("data-comp-name");
          
          const confirm = window.confirm(`Are you sure you want to remove the following component from this key message:\n${name}`);
          if(!confirm) return;
          
          /*------------Remove component from grapesjs----------*/
          // remove block
          const customRcId = `rc-${rcId}`;
          editor.BlockManager.remove(customRcId);
  
          // remove component from html
          const componentsToRemove = editor.getWrapper().find(`[data-rc-id="${rcId}"]`);
          editor.UndoManager.skip(() => {
            for(const component of componentsToRemove) {
              component.remove();
            }
          });
          
          try {
            showLoader();
            const { data } = await deleteRequest(
              `${pathName}/components/${rcId}`,
              {
                headers: {
                  "x-access-token": localStorage.getItem("token"),
                  "x-refresh-token": localStorage.getItem("refreshToken"),
                  changeOrigin: true,
                },
              }
            );
            if(data.isSuccess) {
              await updateUserComponentsList({ editor, pathName, pId, kmId, setMsg, setError });
              setError(false);
              setMsg(data.msg);
            } else console.log(data);
          } catch (err) {
            console.log(err);
            setError(true);
            setMsg(err.message);
          } finally {
            hideLoader();
          }
        })
      );
    } else {
      userCompListHolder.innerHTML = "";
      userCompListHeading.innerHTML = userCompMissingText;
    }
  } catch (err) {
    console.log(err);
    setError(true);
    setMsg(err.message);
  } finally {
    hideLoader();
  }
  
};

export const createComponentManager = async ({ editor, pathName, pId, kmId, setMsg, setError }) => {
  const componentManagerDiv = document.querySelector("#manage-comp");

  if (componentManagerDiv.classList.contains("d-none")) {
    componentManagerDiv.classList = "";
    componentManagerDiv.innerHTML = "";
  }

  const modal = `<div class="fade modal show" role="dialog" aria-modal="true" style="display: block;">
        <div style="padding-right: 17px; top: 40px; display: block;" class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title h5">Component Repository</div>&nbsp
                    <button class="btn-close" aria-label="close"></button>
                </div>
                <div class="modal-body">
                    <div style="height: 300px" id="comp-upload-container">
                        <div class="row">
                            <div class="col" style="height: 280px; overflow: scroll">
                                <div id="global-comp-list">
                                    <h6 id="global-comp-heading">${globalCompMissingText}</h6>
                                    <div class="row g-3 align-items-center">
                                      <div class="col-auto">
                                        <input class="form-control form-control-sm" type="search" id="global-comp-search" />
                                      </div>
                                      <div class="col-auto">
                                        <span id="global-comp-count">0 Components</span>
                                      </div>
                                    </div>
                                    <ul class="list-group" id="global-comp-list-group"></ul>
                                </div>
                            </div>
                            <div class="vr" style="padding: 1px;"></div>
                            <div class="col" style="height: 280px; overflow: scroll">
                                <div id="user-comp-list">
                                    <h6 id="user-comp-heading">${userCompPresentText}</h6>
                                    <ul class="list-group" id="user-comp-list-group"></ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="fade modal-backdrop show"></div>`;

  componentManagerDiv.innerHTML = modal;

  const closeBtn = document.querySelector("#manage-comp .btn-close");
  closeBtn.addEventListener("click", () => {
    componentManagerDiv.className = "d-none";
  });

  // showLoader();
  await updateGlobalComponentsList({ editor, pathName, pId, kmId, setMsg, setError });
  await updateUserComponentsList({ editor, pathName, pId, kmId, setMsg, setError });
  // hideLoader();
};
